import { z } from "zod";
import { UIElementType } from "../../../../AppConstants";
import { t } from "i18next";

const getDeviceSchema = (lookUpData) => {
    console.log("Inside getDeviceSchema lookUpData ::::", lookUpData);
    return z.object({
        LongName: z
            .string()
            .min(1, { message: "Long name is required" })
            .describe(JSON.stringify({ elementType: UIElementType.TEXTFIELD, inputLabel: t("createDevice.longName"), isRequired: true })),
        shortName: z
            .string()
            .min(1, { message: "Short name is required" })
            .describe(JSON.stringify({ elementType: UIElementType.TEXTFIELD, inputLabel: t("createDevice.shortName"), isRequired: true })),
        DeviceType: z
            .object({
                id: z.string(),
                label: z.string(),
            })
            .nullable()
            .refine((value) => value !== null && value?.id !== null, {
                message: "Device Type is required",
            })
            .describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("createDevice.deviceType"),
                    isMultiSelect: false,
                    isRequired: true,
                    options: lookUpData.deviceTypeList ? lookUpData.deviceTypeList : []
                })
            ),
        Type: z
            .object({
                id: z.string(),
                label: z.string(),
            })
            .nullable()
            .refine((value) => value !== null && value?.id !== null, {
                message: "Type is required",
            })
            .describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("createDevice.serviceType"),
                    isMultiSelect: false,
                    isRequired: true,
                    options: lookUpData.serviceTypeList ? lookUpData.serviceTypeList : []
                })
            ),
        InstallationTime: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("createDevice.installationTime"),
                    isRequired: false,
                })
            ),
        MaintenanceTime: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("createDevice.maintenanceTime"),
                    isRequired: false,
                })
            ),
        AgreementCost: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("createDevice.agreementCost"),
                    isRequired: false,
                })
            ),
        GMMaterial: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("createDevice.gmMaterial"),
                    isRequired: false,
                })
            ),
        MyrentokilInstallationTime: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("createDevice.myRentokilInstallationTime"),
                    isRequired: false,
                })
            ),
        MyrentokilMaintenanceTime: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("createDevice.myRentokilMaintenenceTime"),
                    isRequired: false,
                })
            ),
        HasUninstall: z
            .string()
            .describe(JSON.stringify({ elementType: UIElementType.RADIOBUTTON, inputLabel: t("createDevice.hasUninstall"), isRequired: false }))
            .transform((val) => {
                if (typeof val !== "string") return val; // If it's not a string, return as is
                return val.toLowerCase() === "true";
            }),
        MinTimePerVisit: z
            .string()
            .describe(JSON.stringify({ elementType: UIElementType.RADIOBUTTON, inputLabel: t("createDevice.minTimePerVisit"), isRequired: false }))
            .transform((val) => {
                if (typeof val !== "string") return val; // If it's not a string, return as is
                return val.toLowerCase() === "true";
            }),
        UninstallTimePercentage: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("createDevice.uninstallTimePercent"),
                    isRequired: false,
                })
            ),
        InspectionPercentage: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            }).describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("createDevice.inspectionPercent"),
                    isRequired: false,
                })
            ),
        QuantityVisibility: z
            .string()
            .describe(JSON.stringify({ elementType: UIElementType.RADIOBUTTON, inputLabel: t("createDevice.QuantityVisibility"), isRequired: false }))
            .transform((val) => {
                if (typeof val !== "string") return val; // If it's not a string, return as is
                return val.toLowerCase() === "true";
            }),

    });
};

const getDeviceDefaultValue = (value = null) => {
    return {
        LongName: value && value.LongName ? value.LongName : "",
        shortName: value && value.shortName ? value.shortName : "",
        DeviceType: value && value.DeviceType ? value.DeviceType : null,
        Type: value && value.Type ? value.Type : null,
        InstallationTime: value && value.InstallationTime ? value.InstallationTime : 0,
        MaintenanceTime: value && value.MaintenanceTime ? value.MaintenanceTime : 0,
        AgreementCost: value && value.AgreementCost ? value.AgreementCost : 0,
        GMMaterial: value && value.GMMaterial ? value.GMMaterial : 0,
        MyrentokilInstallationTime: value && value.MyrentokilInstallationTime ? value.MyrentokilInstallationTime : 0,
        MyrentokilMaintenanceTime: value && value.MyrentokilMaintenanceTime ? value.MyrentokilMaintenanceTime : 0,
        HasUninstall: value ? (value?.HasUninstall === true || value?.HasUninstall === "true" ? "true" : "false") : "false",
        MinTimePerVisit: value ? (value?.MinTimePerVisit === true || value?.MinTimePerVisit === "true" ? "true" : "false") : "false",
        UninstallTimePercentage: value && value.UninstallTimePercentage ? value.UninstallTimePercentage : 0,
        InspectionPercentage: value && value.InspectionPercentage ? value.InspectionPercentage : 0,
        QuantityVisibility: value ? (value?.QuantityVisibility === true || value?.QuantityVisibility === "true" ? "true" : "false") : "false"
    };
};

const getDeviceAPIPostSchema = (countryCode, businessCode) => {
    return {
        countryCode: countryCode,
        businessCode: businessCode,
        device: [
            {
                DeviceId: "",
                Id: "",
                LongName: null,
                ShortName: null,
                DeviceTypeId: null,
                TypeId: null,
                InstallationTime: 0,
                MaintenanceTime: 0,
                AgreementCost: 0,
                GMMaterial: 0,
                MyrentokilInstallationTime: 0,
                MyrentokilMaintenanceTime: 0,
                HasUninstall: false,
                MinTimePerVisit: false,
                UninstallTimePercentage: 0,
                InspectionPercentage: 0,
                QuantityVisibility: false,
                Frequencies: "1",
                replacementDevice: [
                    {
                        StartFrequencyReposition: "",
                        ReplaceDeviceId: "",
                        EndFrequencyReposition: "",
                        RepositionPercentage: "",
                        Deleted: false
                    },
                ],
                Deleted: false,
                CountryCode: countryCode,
                BusinessCode: businessCode,
            },
        ],
    };
};

const getDeviceAPIDeleteSchema = (countryCode, businessCode) => {
    return {
        countryCode: countryCode,
        businessCode: businessCode,
        device: [
            {
                DeviceId: "",
                Id: "",
                Deleted: false,
                CountryCode: countryCode,
                BusinessCode: businessCode
            },
        ],
    };
};

const getDeviceAuditInfoSchema = () => {
    return {
        auditInfo: [
            {
                Location: "Device",
                LocationKey: "",
                Action: null,
                shortDesc: null,
                currentState: null,
                previousState: null,
            },
        ],
    };
};

export {
    getDeviceSchema,
    getDeviceDefaultValue,
    getDeviceAPIPostSchema,
    getDeviceAPIDeleteSchema,
    getDeviceAuditInfoSchema,
};
